import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from 'react-icons/fa';
import { useContent } from '../contexts/ContentContext';
import './Hero.css';

const Hero = () => {
  const { t, i18n } = useTranslation();
  const { content } = useContent();
  const lang = i18n.language?.startsWith('sk') ? 'Sk' : 'En';
  const hero = content.hero;

  return (
    <section className="hero" id="home">
      <div className="hero__media">
        <video
          className="hero__video"
          autoPlay
          muted
          loop
          playsInline
          poster={hero.posterUrl}
        >
          <source src={hero.videoUrl} type="video/mp4" />
        </video>
        <div className="hero__overlay" />
      </div>

      <div className="hero__content">
        <h1 className="hero__title">
          <span className="hero__word" style={{ animationDelay: '0.2s' }}>
            {hero[`title${lang}`]}
          </span>
        </h1>

        <p className="hero__subtitle">{hero[`subtitle${lang}`]}</p>

        <div className="hero__actions">
          <Link to="/contact-us" className="btn">
            <FaArrowRight /> {t('hero.ctaPrimary')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
